export const SignupView = () => {
  return <div>SignupView</div>;
};
export const SignupRoute = "/auth/signup";
